import { lazy } from 'react';

import { RouteTypes } from '@/types/config-types';

export const protectedRoutes: RouteTypes[] = [
  {
      routeKey: 'home',
      path: '/',
      name: 'Home',
      component: lazy(() => import('@/pages/chat/Chat')),
    },
    {
      routeKey: 'chat',
      path: '/chat',
      name: 'Chat',
      component: lazy(() => import('@/pages/chat/Chat')),
    },
  // {
  //   routeKey: 'profile',
  //   path: '/profile',
  //   name: 'Profile',
  //   component: lazy(() => import('@/pages/profile/Profile')),
  // },
  // {
  //   routeKey: 'my_twin',
  //   path: '/my-twin',
  //   name: 'My Twin',
  //   component: lazy(() => import('@/pages/my-twin')),
  // },
  // {
  //   routeKey: 'get_twin',
  //   path: '/my-twin/landing',
  //   name: 'Get Twin',
  //   component: lazy(() => import('@/pages/my-twin/twin-landing')),
  // },
  // {
  //   routeKey: 'checkout_product',
  //   path: '/checkout/:id',
  //   name: 'Checkout Product',
  //   component: lazy(() => import('@/pages/payment/checkout')),
  // },
  // {
  //   routeKey: 'subscribed_twins',
  //   path: '/subscribed-twins',
  //   name: 'Subscribed Twins',
  //   component: lazy(
  //     () => import('@/pages/explore-twins/subscribedTwins/SubscribedTwins')
  //   ),
  // },
  // {
  //   routeKey: 'buy_points',
  //   path: '/buy-points',
  //   name: 'Buy Points',
  //   component: lazy(() => import('@/pages/buy-points-new/BuyPoints')),
  // },
  // {
  //   routeKey: 'twin_studio',
  //   path: '/twin-studio',
  //   name: 'Twin Studio',
  //   component: lazy(() => import('@/pages/twin-studio/TwinStudio')),
  // },
  // {
  //   routeKey: 'studio_videos',
  //   path: '/twin-studio/collection',
  //   name: 'My Collection',
  //   component: lazy(() => import('@/pages/twin-studio/MyCollection')),
  // },
  // {
  //   routeKey: 'update_twin',
  //   path: '/my-twin/update',
  //   name: 'Update Twin',
  //   component: lazy(() => import('@/pages/my-twin/update-twin/UpdateTwin')),
  // },
  // {
  //   routeKey: 'packages',
  //   path: '/my-twin/packages',
  //   name: 'Update Twin',
  //   component: lazy(
  //     () => import('@/pages/my-twin/twin-landing/components/PricePackages')
  //   ),
  // },
  // {
  //   routeKey: 'manage_plan',
  //   path: '/my-twin/plan',
  //   name: 'Manage Plan',
  //   component: lazy(
  //     () =>
  //       import(
  //         '@/pages/my-twin/twin-dashboard/components/user-twin-plan/ManagePlan'
  //       )
  //   ),
  // },
];

export const protectedRouteNames = protectedRoutes.map((route) => route.name);
export const protectedRoutePaths = protectedRoutes.map((route) => route.path);
